import type {StaffRole} from '@pocketbuy/outdoor-business-types';

export const directorAccountRoles: StaffRole[] = ['DEPUTY_REGIONAL_MANAGER', 'BUSINESS_MANAGER', 'BUSINESS_EXECUTIVE', 'CLUSTER_LEADER'];
export function accountRoleOptions<T extends {value: StaffRole}>(options: T[], role?: StaffRole): T[] {
  return role === 'DIRECTOR' ? options.filter(option => directorAccountRoles.includes(option.value)) : role === 'OPERATIONS' ? options.filter(option => option.value === 'STOCK_KEEPER') : options;
}

export function assignableAccountRoles<T extends {value:StaffRole}>(options:T[],role?:StaffRole):T[]{
  return accountRoleOptions(options,role).filter(option=>option.value!=='CLUSTER_LEADER');
}

export function sharedManagedAccount(roles: StaffRole[], role?: StaffRole): boolean {
  return (role === 'DIRECTOR' || role === 'OPERATIONS') && accountRoleOptions(roles.map(value=>({value})), role).length !== roles.length;
}
